import { type AddHookResponse, mutationAdd } from '../hooks'
import { useTantalimMutation } from '../mutation'
import { useQuestionCache } from './cache'
import { toResponseError, type QuestionAddInput, type QuestionAddSuccess } from '@terros/common'

export function useAddQuestion(): AddHookResponse<QuestionAddInput, QuestionAddSuccess> {
  const cache = useQuestionCache()
  const mutation = useTantalimMutation<QuestionAddInput, QuestionAddSuccess>({
    url: '/question/manage/add',
  })

  async function add(input: QuestionAddInput): Promise<QuestionAddSuccess> {
    try {
      const res = await mutation.mutateAsync(input)
      cache.clearList()
      return res
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
